import {FormControl, FormGroup} from '@angular/forms';

export const DEFAULT_SORT_PROPERTY_NAME = 'id';

export const DEFAULT_PROCESSORS = [
  {
    id: 4,
    displayName: 'Onyx',
  },
  {
    id: 5,
    displayName: 'Tacs',
  },
  {
    id: 6,
    displayName: 'Paymode',
  },
];

export const MAX_FILE_NAME_LENGTH = 16;

export const MAX_CONFIRMATION_NUMBER_LENGTH = 15;

export const MAX_ADX_REFERENCE_LENGTH = 6;

export type CommissionReconciliationForm = FormGroup<{
  ProcessorId: FormControl<number>;
  FileName: FormControl<string>;
  ArrivalDateFrom: FormControl<string>;
  ArrivalDateTo: FormControl<string>;
  DepartureDateFrom: FormControl<string>;
  DepartureDateTo: FormControl<string>;
  HotelConfirmationNumber: FormControl<string>;
  AdxTripReference: FormControl<string>;
}>;

export interface CommissionReconciliationFormValues {
  ProcessorId: number[];
  FileName: string[];
  ArrivalDateFrom: string[];
  ArrivalDateTo: string[];
  DepartureDateFrom: string[];
  DepartureDateTo: string[];
  HotelConfirmationNumber: string[];
  AdxTripReference: string[];
}
